import { findElement, describeElement } from './collect'
import { highlight, clearHighlight, currentHighlightMode } from './highlight'
import { startPicker, refFor, imageDataUrl } from './picker'
import { executeAction } from './execute'

export function createUiBridge({ source, origin, pageKey, post, root = document, fetcher }) {
  let stopPick
  // 每次拾取一个代次：取消/重新拾取后，还在读原图的旧回调不再回传结果。
  let pickToken = 0
  // 从 pick_start 到回传结果（含异步读图）都算拾取中。
  let picking = false
  /** 返回取消前是否在拾取中；notify 时通知 iframe 拾取已作废（宿主侧主动取消用）。 */
  const cancelPick = ({ notify = false } = {}) => {
    const active = picking
    pickToken++
    picking = false
    stopPick?.(); stopPick = undefined
    if (active && notify) post({ type: 'gutdb_ui_pick_cancelled' })
    return active
  }
  return {
    /** 返回 true 表示消息已由本桥处理。 */
    handle(event) {
      if (!event || event.source !== source() || event.origin !== origin()) return false
      const data = event.data || {}
      if (data.type === 'gutdb_ui_highlight') {
        try {
          // 点 chip 的 3 秒定位气泡不因指针离开 chip 而消失。
          if (data.mode === 'clear') { if (currentHighlightMode() !== 'focus') clearHighlight(); return true }
          const target = typeof data.id === 'string' ? findElement(pageKey(), data.id, root) : undefined
          if (target) highlight(target, { mode: data.mode === 'focus' ? 'focus' : 'hover', label: describeElement(target).label })
        } catch { /* 高亮失败不影响宿主 */ }
        return true
      }
      if (data.type === 'gutdb_ui_pick_start') {
        cancelPick()
        const token = pickToken
        const current = () => token === pickToken
        const settle = message => { if (!current()) return; picking = false; post(message) }
        picking = true
        try {
          stopPick = startPicker({
            pageKey: pageKey(), root,
            onPick: async target => {
              stopPick = undefined
              try {
                const ref = refFor(target)
                const img = target.entry.image?.(target.el)
                const image = img ? await imageDataUrl(img, fetcher) : null
                settle({ type: 'gutdb_ui_picked', ref: img && !image ? { ...ref, imageUnavailable: true } : ref, ...(image ? { image } : {}) })
              } catch { settle({ type: 'gutdb_ui_pick_cancelled' }) }
            },
            onCancel: () => { stopPick = undefined; settle({ type: 'gutdb_ui_pick_cancelled' }) },
          })
        } catch { stopPick = undefined; settle({ type: 'gutdb_ui_pick_cancelled' }) }
        return true
      }
      if (data.type === 'gutdb_ui_pick_cancel') { cancelPick(); return true }
      if (data.type === 'gutdb_ui_action') {
        const requestId = String(data.requestId ?? '').slice(0, 64)
        let result
        try { result = executeAction(data, { currentPageKey: pageKey(), root }) }
        catch { result = { ok: false, reason: '执行失败' } }
        post({ type: 'gutdb_ui_action_ack', requestId, ...result })
        return true
      }
      return false
    },
    cancelPick,
    dispose() { cancelPick(); clearHighlight() },
  }
}
